import React from 'react'
import SignupForm from "./SignUpForm";
import ValidateForm from "../../helpers/ValidateForm";
import GetDataApi from "../../helpers/GetDataApi";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import AppToast from "../../ui/AppToast";
import Redirect from "../../helpers/Redirect";
import Header from "../../components/Header";
import ValidateEmail from "../../helpers/ValidateEmail";
import ValidateMinTel from "../../helpers/ValidateMinTel";
import {withRouter} from 'react-router';
import AlertVerifyEmail from "./AlertVerifyEmail";
import {validarContrasenaSegura} from "../../helpers/Helpers";

class Signup extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            form: {
                documentoTipoID: {
                    key: 'documentoTipoID',
                    value: '',
                    required: true
                },
                terceroDocumento: {
                    key: 'terceroDocumento',
                    value: '',
                    required: true
                },
                terceroNombre1: {
                    key: 'terceroNombre1',
                    value: '',
                    required: true
                },
                terceroNombre2: {
                    key: 'terceroNombre2',
                    value: '',
                    required: false
                },
                terceroApellido1: {
                    key: 'terceroApellido1',
                    value: '',
                    required: true
                },
                terceroApellido2: {
                    key: 'terceroApellido2',
                    value: '',
                    required: false
                },
                terceroMail: {
                    key: 'terceroMail',
                    value: '',
                    required: true
                },
                terceroTel: {
                    key: 'terceroTel',
                    value: '',
                    required: false
                },
                terceroCel: {
                    key: 'terceroCel',
                    value: '',
                    required: false
                },
                terceroDireccion: {
                    key: 'terceroDireccion',
                    value: '',
                    required: true
                },
                terceroPassword: {
                    key: 'terceroPassword',
                    value: '',
                    required: true
                },
                terceroPasswordConfirm: {
                    key: 'terceroPasswordConfirm',
                    value: '',
                    required: true
                },
            },
            url: '',
            loadData: {
                documentTypes: []
            },
            openModal: false,
            aceptaPP: false,
            aceptaTD: false,
        };

        this.agreePP = this.agreePP.bind(this);
        this.agreeTD = this.agreeTD.bind(this);
    }

    componentDidMount() {
        this.getDocumentTypes();
    }

    getDocumentTypes = async () => {
        const data = await Api.get(`${Env.UrlSeguridad}/getDocumentoTipo`);
        if (data.cod === '1') {
            this.setState({
                loadData: {
                    documentTypes: data.DocumentoTipo
                }
            });
        } else {
            AppToast(data.message, false);
        }
    }

    validateConfirmPassword = (password, confirmPassword) => {
        if (password !== confirmPassword) {
            AppToast('Las contraseñas no coinciden!', false);
            return false;
        }
        return true;
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        if (!this.validate()) {
            return;
        }

        this.setState({openModal: true});
    }

    validate = () => {
        // Valida los campos obligatorios
        if (!ValidateForm(this.state.form)) {
            return false;
        }

        // Valida que ingrese mínimo un número
        if (!ValidateMinTel(this.state.form.terceroTel.value, this.state.form.terceroCel.value)) {
            return false;
        }

        // Valida formato del email
        if (!ValidateEmail(this.state.form.terceroMail.value)) {
            AppToast('El email no tiene un formato válido!', false);
            return false;
        }

        if (!validarContrasenaSegura(this.state.form.terceroPassword.value)) {
            AppToast('¡La contraseña ingresada no es válida!', false);
            return false;
        }

        // Valida que las contraseñas coincidan
        if (!this.validateConfirmPassword(this.state.form.terceroPassword.value, this.state.form.terceroPasswordConfirm.value)) {
            return false;
        }

        if (!this.state.aceptaPP) {
            AppToast('¡Debe aceptar la política de privacidad!', false);
            return false;
        }

        if (!this.state.aceptaTD) {
            AppToast('¡Debe aceptar la política de tratamiento de datos!', false);
            return false;
        }

        return true;
    }

    handleChange = (e) => {
        const {value, name} = e.target;

        this.setState((statePrev) => {
            return {
                form: {
                    ...statePrev.form,
                    [name]: {
                        ...statePrev.form[name],
                        value: value
                    }
                }
            }
        });
    }

    handleCloseModal = () => {
        this.setState({openModal: false});
    }

    save = async () => {

        this.handleCloseModal();

        let result;
        // --- ACEPTACIÓN POLITICA PRIVACIDAD
        result = await Api.post(`${Env.UrlBackend}/privacy-policy/update`, {
            user: this.state.form.terceroMail.value,
            type: 'PP',
            agree: 'S',
            source: Env.ApplicationCode
        });
        if (!result.success) {
            AppToast(result.message, false);
            return;
        }

        // --- ACEPTACIÓN TRATAMIENTO DATOS
        result = await Api.post(`${Env.UrlBackend}/privacy-policy/update`, {
            user: this.state.form.terceroMail.value,
            type: 'TD',
            agree: 'S',
            source: Env.ApplicationCode
        });
        if (!result.success) {
            AppToast(result.message, false);
            return;
        }

        // --- CREACION DEL USUARIO
        let params = GetDataApi(this.state.form);
        const data = await Api.post(`${Env.UrlSeguridad}/postTercero`, params);
        if (data.cod === '1') {
            AppToast('El usuario se creó con éxito!', true);
            this.setState({
                url: '/accounts'
            });
        } else {
            AppToast(data.msg, false);
        }

    }

    agreePP(agree) {
        this.setState({aceptaPP: agree})
    }

    agreeTD(agree) {
        this.setState({aceptaTD: agree})
    }

    render() {
        return (
            <div>
                <Redirect url={this.state.url}/>

                <Header/>

                <SignupForm
                    form={this.state.form}
                    onChange={this.handleChange}
                    onSubmit={this.handleSubmit}
                    loadData={this.state.loadData}
                    agreePP={this.agreePP}
                    agreeTD={this.agreeTD}
                    aceptaPP={this.state.aceptaPP}
                    aceptaTD={this.state.aceptaTD}
                />

                <AlertVerifyEmail
                    save={this.save}
                    openModal={this.state.openModal}
                    onCloseModal={this.handleCloseModal}
                />

            </div>
        );
    }

}

export default withRouter(Signup)
